// Мастерская (UX-вайрфрейм, экран 08) — стаб до M4 UGC: вход и связи
// зафиксированы (карта → мастерская, палитра ← коллекция, публикация → каталог),
// сам конструктор появится с createEditor контракта (GT-11/12).

import { Link } from 'react-router-dom';
import { SubHeader } from '@/meta/Shell';

export function WorkshopScreen() {
  return (
    <main className="meta-screen" data-testid="screen-workshop">
      <SubHeader title="Мастерская" />
      <div className="meta-body">
        <div className="stub-frame">
          <span aria-hidden="true" style={{ fontSize: 40 }}>🧱</span>
          <h2>Конструктор уровней скоро откроется</h2>
          <p>
            Здесь соберёшь свой уровень: старт жителя, инструменты по сетке, портал —
            и опубликуешь его в каталог. Палитра — из деталей, открытых в коллекции.
          </p>
          <Link to="/collection" className="btn btn-sm" data-testid="workshop-to-collection">
            Посмотреть открытые детали
          </Link>
        </div>
      </div>
    </main>
  );
}
